export default "__VITE_ASSET__71959e94__"